import React from 'react';

/** One row in an action sheet: glyph, worded label, consequence hint. */
export function SheetAction({
  glyph = '\u25b8', label, hint, destructive = false, disabled = false, onClick, style
}) {
  const color = disabled ? 'var(--bujo-text-disabled)'
    : destructive ? 'var(--bujo-state-error)' : 'var(--bujo-text-primary)';
  return (
    <div onClick={disabled ? undefined : onClick} style={{
      display: 'flex', alignItems: 'center', gap: 'var(--bujo-space-3)',
      minHeight: 'var(--bujo-tap-min)', borderTop: '1px solid var(--bujo-rule-hairline)',
      cursor: onClick && !disabled ? 'pointer' : 'default', ...style
    }}>
      <span style={{
        width: 20, flex: 'none',
        font: 'var(--bujo-fw-regular) var(--bujo-glyph-15)/var(--bujo-lh-tight) var(--bujo-font-mono)',
        color: disabled ? 'var(--bujo-text-disabled)'
          : destructive ? 'var(--bujo-state-error)' : 'var(--bujo-accent)'
      }}>{glyph}</span>
      <span style={{
        flex: 1,
        font: 'var(--bujo-fw-regular) 13.5px/var(--bujo-lh-tight) var(--bujo-font-mono)', color
      }}>{label}</span>
      {hint ? (
        <span style={{
          flex: 'none',
          font: 'var(--bujo-fw-regular) 10.5px/var(--bujo-lh-tight) var(--bujo-font-mono)',
          color: 'var(--bujo-text-meta)'
        }}>{hint}</span>
      ) : null}
    </div>
  );
}
